import { derived } from 'svelte/store';
import { store } from '../../store';
export const ControlType = {
    Panel: 0,
    Scroll: 1,
    Enter: 2,
    Up: 3,
    Down: 4,
    Left: 5,
    Right: 6,
    Control: 7,
};
export const getControlKeyName = (type) => {
    switch (type) {
        case 0:
            return 'Panel';
        case 1:
            return 'Scroll';
        case 2:
            return 'Enter';
        case 3:
            return 'Up';
        case 4:
            return 'Down';
        case 5:
            return 'Left';
        case 6:
            return 'Right';
        case 7:
            return 'Control';
        default: {
            console.error('this control type not supported');
            return '';
        }
    }
};
export const getAddControlWords = (type) => {
    switch (type) {
        case 0:
            return 'トラックパッドを追加する';
        case 1:
            return 'スクローラーを追加する';
        case 2:
            return 'エンターキーを追加する';
        case 3:
            return '↑キーを追加する';
        case 4:
            return '↓キーを追加する';
        case 5:
            return '←キーを追加する';
        case 6:
            return '→キーを追加する';
        case 7:
            return 'Ctrlキーを追加する';
        default: {
            console.error('this control type not supported');
            return '';
        }
    }
};
export const windowStyle = derived(store.setting, ($setting) => {
    if (!$setting) {
        return '';
    }
    return `position: absolute; ${getStyleFromRect($setting.windowRect)}`;
});
export const controlsStyle = derived(store.setting, ($setting) => {
    if (!$setting) {
        return '';
    }
    return `position: absolute; ${getStyleFromRect($setting.controlRect)}`;
});
export const controlStyles = derived(store.setting, ($setting) => {
    if (!$setting) {
        return [];
    }
    const res = [];
    for (const template of $setting.controlTemplates) {
        if (!template) {
            continue;
        }
        const controlStyle = { id: template.id, controls: [] };
        for (const control of template.controls) {
            controlStyle.controls.push({
                type: control.type,
                style: getStyleFromControl(control)
            });
        }
        res.push(controlStyle);
    }
    return res;
});
export const getStyleFromRect = (rect) => {
    return `
    width: ${rect.width}; height: ${rect.height}; left: ${rect.start.x}; top: ${rect.start.y};
  `;
};
const getRGBA = (rgba) => {
    return `rgba(${rgba.join(',')})`;
};
export const getStyleFromControl = (control) => {
    return `position: absolute; ${getStyleFromRect(control.rect)} z-index: ${control.zIndex}; background-color: ${getRGBA(control.color)};`;
};
